import { React, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import { Container } from 'react-bootstrap';
import product1 from '../../Assets/product1.png';
import product2 from '../../Assets/product2.png';
import product3 from '../../Assets/product3.png';
import product4 from '../../Assets/product4.png';

const OurProducts = () => {
	useEffect(() => {
		AOS.init({ duration: 2000 });
	}, []);

	const fontSize = {
		fontSize: '1.07rem',
	};
	const products = [
		{
			productImg: product1,
			productName: " User's App",
			productDes:
				'This enables customers to easily make deliveries and track them',
			id: 1,
		},
		{
			productImg: product2,
			productName: " Rider's App",
			productDes: 'This enables riders to easily view and accept deliveries',
			id: 2,
		},
		{
			productImg: product3,
			productName: ' Admin Webapp',
			productDes:
				'This provides analysis of your company performance. It also enables you assign orders to riders and track them',
			id: 3,
		},
		{
			productImg: product4,
			productName: 'Website',
			productDes:
				'This enables customers to easily make deliveries and track them',
			id: 4,
		},
	];

	return (
		<Container
			id='ourProducts'
			className='row mx-auto my-3 pt-5 text-center text-md-start'
			data-aos='fade-up'
		>
			<div className='text-center mb-5'>
				<div className='fs-3 mt-4  display-6 fw-bold py-2'>
					Delivery Service Apps
				</div>
				<div className='my-3' style={{ fontSize: '0.8rem' }}>
					Our delivery service apps offer the following
					<br /> suits of service portals
				</div>
				<Link to='/About'>
					<button
						className={`btn btn-lg text-white fs-6`}
						type='button'
						onClick={() => {
							window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
						}}
						style={{ background: '#28B672' }}
					>
						Get Started
					</button>
				</Link>
			</div>
			{products.map((product) => {
				return (
					<div className='col-12 col-md-6 text-start' key={product.id}>
						<div>
							<img
								src={product.productImg}
								alt='Product images'
								className='img-fluid pt-3'
							/>
						</div>
						<div className='my-4 text-start'>
							<h4 className='fw-bold'>{product.productName}</h4>
							<p style={fontSize}>{product.productDes}</p>
						</div>
					</div>
				);
			})}
		</Container>
	);
};

export default OurProducts;
